import { NgModule } from '@angular/core';
import { StaffPlanProjetoListComponent } from '../staff-plan-projeto/staff-plan-projeto-list.component';
import { StaffPlanProjetoFormComponent } from '../staff-plan-projeto/staff-plan-projeto-form.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    StaffPlanProjetoListComponent,
    StaffPlanProjetoFormComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    StaffPlanProjetoListComponent
  ]
})
export class StaffPlanProjetoModule { }
